export default function initFetch() {
  window.BSFetch = async (urlAppend, opts={}) => {
    const baseUrl = window.configs.baseUrl
    const fetchRes = await fetch(baseUrl + urlAppend, opts)
    return fetchRes
  }
}